module.exports = __webpack_public_path__ + "resources/img/img_passxpertv4_5.1bf69ac1627c722b968a4739e949d173.png";